module.exports = __webpack_public_path__ + "imgs/HauteBox.edd845ad4ac4823be0923f6b01ddf862.png";